/**
 * New-warehouse route — thin shim mounting `<WarehouseComposerPage />`.
 *
 * Edit mode lives at `$warehouseId.edit.tsx` and reuses the same component
 * with `loadWarehouseId` set.
 *
 * @see apps/web/src/features/inventory/warehouses/warehouse-composer-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { WarehouseComposerPage } from "../../../../features/inventory/warehouses/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/warehouses/new")({
  component: NewWarehouseRoute,
});

function NewWarehouseRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Warehouses", to: "/inventory/warehouses" },
        { label: "New warehouse" },
      ]}
      viewportClassName="p-0"
      contentClassName="max-w-none h-full"
      disableViewportScroll
    >
      <WarehouseComposerPage />
    </WorkspaceShell>
  );
}
